import { createContext } from 'react';
import { defaultGraph } from '../../../utils';
import { SSGraph } from '../../../types';

export const GraphRefContext = createContext<{ current: SSGraph }>({
  current: defaultGraph(),
});
